/**
 * Blueprint for multi-option field (i.e. RadioGroup, Dropdown, or Checkboxes)
 * @param {string} id id
 * @param {string} title title
 * @param {any[]} options options
 * @param {boolean} required required
 * @param {any} value value
 * @param {string|null} hint hint
 * @param {boolean} visible visible
 * @param {string} error error
 * @constructor
 */
const MultiOptionField = function(
  id,
  title,
  options,
  required,
  value = null,
  hint = null,
  visible = true,
  error = null
) {
  return {
    id,
    title,
    options,
    required,
    value,
    hint,
    visible,
    error
  };
};

export default MultiOptionField;
